// src/api/axiosInstance.js
import axios from 'axios';
import { logout } from './Logout';
import { notification } from 'antd';
const host = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: host,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,  
  (error) => {
    if (error.response && error.response.status === 401) {  
      logout();
      return new Promise(() => {});
    }else if (error.response && error?.response?.status === 400) {
       notification.error({
        key: 'Bad Request', 
        description:error.response.data?.detail || "Bad Request",
        placement: 'topRight',
        duration:2
      });
      return new Promise(() => {});
    }


    return Promise.reject(error);
  }
);

export default axiosInstance;
